import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import Card from "../../Components/VoteCard/Card";
import { Navigate } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import MyBackDrop from "../../Components/Modals/backDrop";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { getSenateCandidates, getUserVotes } from "../../Sevices/api-requests";
import { mergeClasses } from "@material-ui/styles";
import { Typography, Link } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useParams } from "react-router-dom";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      marginTop: "5%",
      marginBottom: "5%",
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
  })
);
const SenateVotes = ({ user }) => {
  const [senate, setSenate] = useState([]);
  const [voted, setVoted] = useState(false);

  useEffect(() => {
    getCandidates();
  }, []);

  let { userId, level } = useParams();
  const classes = useStyles();

  const getCandidates = () => {
    const senates = getSenateCandidates(level).then((result) => {
      setSenate(result.data.data);
      getUserVotes(userId).then((result2) => {
        const newResult = result2.data.data.filter((vote) => {
          return vote.category === "legislative";
        });
        if (newResult.length === 5) {
          setVoted(true);
        }

        if (
          newResult.length < 5 &&
          newResult.length === result.data.data.length
        ) {
          setVoted(true);
        }
      });
      return result;
    });
  };


  //console.log(position );
  //  const myMap = position? Object.keys(position).map(key=>  {
  //   return {name:key, votes:Object.values([position[key]])}
  // }):[]
  //const {currentUser} = user
  //  const {level} = currentUser
  //console.log(myMap)
  return !user ? (
    <Navigate replace to="/login" />
  ) : (
    <div>
      {!voted ? (
        <div>
          <Typography
            style={{ textAlign: "center", fontSize: "20px", marginTop: "2%" }}
          >
            <Link
              href="/executives"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              {" "}
              <ArrowBackIcon />
              <b>Go to executives</b>
            </Link>
          </Typography>

          <Grid
            container
            style={{ marginLeft: "5%" }}
            alignContent="center"
            justifyContent="center"
            className={classes.root}
            spacing={4}
          >
            {senate.map((senator, id) => {
              return (
                <Card
                  key={id}
                  name={senator.name}
                  category="legislative"
                  reload={getCandidates}
                  level={user.level}
                  userId={user._id}
                  image={senator.image}
                  position={senator.position}
                />
              );
            })}
          </Grid>

          <Link className="centre" to="/election/executives">
            Done with senate? Click to vote for executives
          </Link>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            marginTop: "40vh",
          }}
        >
          <Typography>
            {user.firstName}, Your votes have been recorded.!!
          </Typography>
          <Typography
            style={{ textAlign: "center", fontSize: "20px", marginTop: "2%" }}
          >
            <Link
              href="/executives"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              {" "}
              <ArrowBackIcon />
              <b>Go to executives</b>
            </Link>
          </Typography>
        </div>
      )}
    </div>
  );
};

export default SenateVotes;
